module.exports = __webpack_public_path__ + "img/heart.915c4d71.png";